// extracted by mini-css-extract-plugin
export default {"BookedDayDetails_time_venue_details":"BookedDayDetails_BookedDayDetails_time_venue_details__1N-Ux"};